export default __webpack_public_path__ + "static/media/bill-payment.fb656dd8.png";